export default {
  components: {},
  props: {},
  data() {
    return {
      basicSkills_show: true,
      ambientOcclusionOnly: false,
      intensity: 3.0,
      lengthCap: 0.2,
      stepSize: 1.0,
      bias: 0.1,
      blurStepSize: 0.1,
      delayShow: false,
      FxaaShow: false,
      AOShow: false,
      isFold: false,
    };
  },
  mounted() {
    // alert(this.$GLOBAL.testVal+'456');
    // this.$refs["multipleTable"].$nextTick(function () {
    //            this.escrollY(
    //              ".el-table__body-wrapper",
    //              ".el-table__header-wrapper"
    //            );
    // 		   console.log('触发！');
    //          })
  },
  methods: {
    basicSkillsBox_close() {
      this.$emit("basicSkillsBox_close");
    },
    // basicSkills_showFullscreen(){
    // 	Cesium.Fullscreen.requestFullscreen(document.body)
    // },
    showDebug() {
      this.$GLOBAL.map.viewer.scene.debugShowFramesPerSecond = this.delayShow;
      if (this.delayShow) {
        $(".mars3d-compass").hide();
        this.$message({
          message: "已开启 显示延迟和帧数。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        $(".mars3d-compass").show();
        this.$message({
          message: "已关闭 显示延迟和帧数。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    showFxaa() {
      //this.$GLOBAL.map.viewer.scene.highDynamicRange = this.FxaaShow;
      this.$GLOBAL.map.viewer.scene.postProcessStages.fxaa.enabled = this.FxaaShow;
      this.$GLOBAL.map.viewer.scene.globe.enableLighting = this.FxaaShow;

      if (this.FxaaShow) {
        this.$message({
          message: "已开启 反锯齿。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        this.$message({
          message: "已关闭 反锯齿。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
    showAO() {
      this.$GLOBAL.map.scene.postProcessStages.ambientOcclusion.enabled = this.AOShow;
      if (this.AOShow) {
        this.$message({
          message: "已开启 AO效果。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      } else {
        this.$message({
          message: "已关闭 AO效果。",
          type: "success",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },

    // basicSkills_showAttribute(){
    //   AttributeTableComponent.attributeDivShow = !AttributeTableComponent.attributeDivShow;
    // }
  },
  watch: {},
  destroyed() {
    this.$GLOBAL.map.viewer.scene.debugShowFramesPerSecond = false;
    this.$GLOBAL.map.viewer.scene.postProcessStages.fxaa.enabled = false;
    this.$GLOBAL.map.viewer.scene.globe.enableLighting = false;
    this.$GLOBAL.map.scene.postProcessStages.ambientOcclusion.enabled = false;
  },
};
